__turbopack_context__.v({
  "benefit-item": "style-module-scss-module__1j1Mha__benefit-item",
  "component": "style-module-scss-module__1j1Mha__component",
});
